import type { NormalisationArtifactKind } from "../types/normalisationRun";

const ARTIFACT_FILE_BY_KIND: Record<NormalisationArtifactKind, string> = {
  detail: "detail.csv",
  summary: "summary.csv",
  super: "super.csv",
  issues: "issues.csv",
  bundle: "bundle.zip",
};

/** PRD-facing download basename suffix (Api artifact keys stay `detail.csv` / `summary.csv`). */
const DOWNLOAD_BASENAME_SUFFIX: Record<NormalisationArtifactKind, string> = {
  detail: "component",
  summary: "gross",
  super: "super",
  issues: "issues",
  bundle: "bundle",
};

export function normalisationArtifactFileName(
  kind: NormalisationArtifactKind,
): string {
  return ARTIFACT_FILE_BY_KIND[kind];
}

/** User-facing download name: import file basename + PRD extract label. */
export function normalisationArtifactDownloadFilename(
  importFileName: string,
  kind: NormalisationArtifactKind,
): string {
  const baseName = importFileName.replace(/\.[^./\\]+$/i, "").trim();
  const safeBase = baseName !== "" ? baseName : "client-pay-import";
  const suffix = DOWNLOAD_BASENAME_SUFFIX[kind];
  if (kind === "bundle") {
    return `${safeBase}-${suffix}.zip`;
  }
  return `${safeBase}-${suffix}.csv`;
}

/** Parse `Content-Disposition` filename when present. */
export function parseContentDispositionFilename(
  header: string | undefined,
  fallback: string,
): string {
  if (header === undefined || header === "") {
    return fallback;
  }
  const quoted = /filename\*?=(?:UTF-8''|")?([^";]+)/i.exec(header);
  if (quoted?.[1]) {
    return decodeURIComponent(quoted[1].replace(/"/g, ""));
  }
  return fallback;
}
